<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent :initial="year" @change="handleYearChange" />
      </el-col>
      <el-col :span="3">
        <MonthsComponent :initial="month" @change="handleMonthChange" />
      </el-col>
      <el-col :span="3">
        <el-select
          clearable
          v-model="selectedWeek"
          placeholder="Seleccione una semana"
          @change="GetReport"
          size="small"
        >
          <el-option
            v-for="week in weeks"
            :key="week.value"
            :label="week.label"
            :value="week.value"
          />
        </el-select>
      </el-col>
    </el-row>

    <!-- -->
    <rabbey-table-3 :data="reportData" :columns="columns" :actions="[]">
    </rabbey-table-3>
  </div>
</template>

<script>
import { Columns } from "@/columns/DealRequiredActivitiesReport/DealRequiredActivitiesReportColumns";
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1; // Months are zero-based, so we add 1

export default {
  name: "DealsActivitiesRequiredReport",
  components: {
    YearsComponent,
    MonthsComponent
  },
  data() {
    return {
      columns: Columns,
      reportData: [],
      year: currentYear,
      month: currentMonth,
      selectedWeek: "",
      weeks: [
        {
          value: "s1",
          label: "Semana del 1 al 7"
        },
        {
          value: "s2",
          label: "Semana del 8 al 14"
        },
        {
          value: "s3",
          label: "Semana del 15 al 21"
        },
        {
          value: "s4",
          label: "Semana del 22 al 28"
        },
        {
          value: "s5",
          label: "Semana del 29 al 31"
        }
      ]
    };
  },

  mounted() {
    this.GetReport();
  },

  methods: {
    async GetReport() {
      let body = {
        params: {
          year: this.year,
          month: this.month,
          week: this.selectedWeek
        }
      };
      await this.$http
        .get("/api/deals/RequiredActionReport", body)
        .then((response) => {
          this.reportData = response.data;
        })
        .catch((error) => {
          console.error("Error fetching report data:", error);
        });
    },
    handleYearChange(newYear) {
      this.year = newYear;
      this.GetReport();
    },
    handleMonthChange(newMonth) {
      this.month = newMonth;
      this.GetReport();
    }
  }
};
</script>

<style scoped></style>
